import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { dayWiseCustomerPOBDataType } from "../../../domain/models/daily-pob-report/daywisecustomerpobreport";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import { RemoteFetchDayWiseCustomerPOBReport } from "../../../data/usecases/daily-pob-report/remote-day-wise-customer-pob-report";
import Endpoints from "../../../domain/endpoints";
import { FetchDayWiseCustomerPOBReport } from "../../../domain/useages/daily-pob-report/fetch-day-wise-customer-pob-report";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchDayWiseCustomerPOBReportInterface {
  DayWiseCustomerPOBData: dayWiseCustomerPOBDataType;
  DayWiseCustomerPOBDataState: FetchState;
  fetchDayWiseCustomerPOBData: Function;
}

const initialStates = {
  DayWiseCustomerPOBData: {} as dayWiseCustomerPOBDataType,
  DayWiseCustomerPOBDataState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFetchDayWiseCustomerPOBReport: StateCreator<
  FetchDayWiseCustomerPOBReportInterface
> = (set) => ({
  ...initialStates,
  fetchDayWiseCustomerPOBData: async (
    params: FetchDayWiseCustomerPOBReport.Params
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteDayWiseCustomerPOBReport =
      new RemoteFetchDayWiseCustomerPOBReport(
        `${BASE_URL}${Endpoints.FETCH_DAY_WISE_CUSTOMER_POB_REPORT}`,
        axiosHttpClient
      );

    set(() => ({ DayWiseCustomerPOBDataState: FetchState.LOADING }));
    let result = await remoteDayWiseCustomerPOBReport.fetch(params);

    set(() => ({
      DayWiseCustomerPOBData: result,
      DayWiseCustomerPOBDataState: FetchState.SUCCESS,
    }));
  },
});
